var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar2 = function SvgStar2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.545 1.004a.5.5 0 0 1 .91 0l1.103 2.432a.5.5 0 0 0 .4.29l2.653.297a.5.5 0 0 1 .281.866L8.92 6.69a.5.5 0 0 0-.152.47l.537 2.615a.5.5 0 0 1-.737.535L6.247 8.99a.5.5 0 0 0-.494 0l-2.321 1.32a.5.5 0 0 1-.737-.536l.537-2.615a.5.5 0 0 0-.152-.47l-1.972-1.8a.5.5 0 0 1 .281-.866l2.653-.297a.5.5 0 0 0 .4-.29z"
  })));
};
export default SvgStar2;